import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 14.107a3.03 3.03 0 0 1-3.027 3.028H2V2h7.893C16.579 2 22 7.42 22 14.107M8.459 7.145a.417.417 0 0 0-.417-.416H5.066a.417.417 0 0 0-.417.416v4.842c0 .23.187.416.417.416h2.976c.23 0 .417-.186.417-.416zm8.57 4.925a5.34 5.34 0 0 0-5.341-5.341h-1.355a.417.417 0 0 0-.417.416v4.842c0 .23.187.416.417.416h6.362a.334.334 0 0 0 .334-.333"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2.838",
      height: "20",
      x: "22",
      y: "19.162",
      fill: "currentColor",
      rx: "1.419",
      transform: "rotate(90 22 19.162)"
    }, null, -1)
  ])))
}
export default { render: render }